import { Checkbox, Tooltip } from "@mui/material";
import styles from "./prospectcard.module.css";
import { Link, useHistory } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { Dropdown } from "react-bootstrap";
import { Archive, AtSign, Award, Mail, MoreVertical, Send, Trash2 } from "react-feather";
import { styled } from "@mui/material/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import moment from "moment";

const BootstrapTooltip = styled(({ className, ...props }) => (<Tooltip {...props} arrow classes={{ popper: className }} />))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        fontSize: 13,
    },
}));

const getSlaTooltipData = (item) => {
    let txt = "Salary - N/A";
    let txt2 = "";
    if (item?.income_type === "Voucher") {
        txt = "Voucher - $" + item?.formatted_voucher_amount;
    } else if (item?.income_per_year !== "") {
        txt = "Salary - $" + item?.formatted_income_per_year;
    }

    if (item?.is_employement2 === 1) {
        if (item?.income_type2 === "Voucher" && item?.voucher_amount2 !== "") {
            txt2 = "Voucher2 - " + new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(item?.voucher_amount2);
        } else if (item?.income_per_year2 !== "") {
            txt2 = "Salary2 - " + new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(item?.income_per_year2);
        }
    }

    return (<div>{txt}<br />{txt2}</div>);
}

const ProspectCard = ({ item, isOpenEmailGroup, selectedProspectForEmailGroup, handleProspectToggle, setOpenDeleteModal, setOpenLeaderBoardModal, setArchiveModalOpen, setApplicationModalOpen, setDeleteId, setArchiveId, setIsArchived, setIsOpenEmailGroup, initiateVoiceCall, openProspectConversation }) => {
    const { user, isAuthenticated } = useAuth0();
    const redirect = useHistory();

    return (<div className={`${styles.ProspectCard}`}>
        <Link to={`/people/prospects/details/${item.id}`}>
            <div className={`${styles.ProspectCardUnder}`}>
                <div className={`${styles.ProspectCardHeadSection}`}>
                    {isOpenEmailGroup && (<div onClick={(e) => { e.stopPropagation(); }}>
                        <Checkbox
                            className={styles.AddEmailCheckbox}
                            checked={selectedProspectForEmailGroup.includes(item?.id)}
                            onChange={(e) => { handleProspectToggle(item.id, item?.email); }}
                        />
                    </div>)}
                    <div className={`${styles.ProsIMGSec}`}>
                        {item?.user_avatar !== "" ? (<img src={item?.user_avatar} className={`${styles.defaultImg}`} alt="" />) : item?.initial !== "?" ? (<p>{item?.initial}</p>) : (<img src="/static/img/DefaultLogo.png" className={`${styles.defaultImg}`} alt="" />)}
                    </div>

                    <div className={`${styles.HeadConSec}`}>
                        <div className={`${styles.prospectNameActionSec}`}>
                            <Tooltip title={item?.full_name} placement="bottom-start">
                                <p className={`${styles.ProsUserName} ${styles.LimitName}`}>
                                    {item?.full_name !== "" ? item?.full_name : "-"}{" "}
                                    {item?.is_verified === 1 && (<img src="/static/img/verified.svg" className={`${styles.Varified}`} alt="" />)}
                                </p>
                            </Tooltip>
                            {item?.is_archived === 1 && (<span className={`${styles.ProspectNonAppliedBadge}`}>Archived</span>)}
                            {item?.is_archived === 0 && item?.airbnb_guest === 1 && (<span className={`${styles.ProspectAirbnbBadge}`}>Airbnb Guest</span>)}
                            {item?.is_archived === 0 && item?.airbnb_guest === 0 && (<>
                                {item?.current_status === 0 && (<span className={`${styles.ProspectNonAppliedBadge}`}>Not Applied</span>)}
                                {item?.current_status === 1 && (<span className={`${styles.ProspectAppliedBadge}`}>Applied</span>)}
                                {item?.current_status === 2 && (<span className={`${styles.ProspectScreenedBadge}`}>Screened</span>)}
                                {item?.current_status === 3 && (<span className={`${styles.ProspectApprovedBadge}`}>Approved</span>)}
                                {item?.current_status === 4 && (<span className={`${styles.ProspectDeclinedBadge}`}>Declined</span>)}
                            </>)}

                            <Dropdown className={`${styles.CardActionBU}`} onClick={(e) => { e.preventDefault(); }}>
                                <Dropdown.Toggle className={`${styles.ActionsBU} ProsDrBU`} id="dropdown-basic">
                                    <MoreVertical />
                                </Dropdown.Toggle>

                                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                                    {item?.is_payment === 0 && item?.is_applied === 1 && (<Dropdown.Item className={`${styles.ActionsBUListItem}`} onClick={(e) => { setOpenDeleteModal(false); setOpenLeaderBoardModal(false); setArchiveModalOpen(false); setApplicationModalOpen(true); setDeleteId(0); setArchiveId(item?.id); setIsArchived(0); }} >
                                        <Send /> Send Application Link
                                    </Dropdown.Item>)}
                                    <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setIsOpenEmailGroup(true); handleProspectToggle(item.id, item?.email); }}>
                                        <AtSign /> Add to email group
                                    </Dropdown.Item>
                                    {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect:update") > -1 && <Dropdown.Item className={`${styles.ActionsBUListItem}`} onClick={(e) => { setOpenDeleteModal(false); setOpenLeaderBoardModal(false); setApplicationModalOpen(false); setArchiveModalOpen(true); setDeleteId(0); setArchiveId(item?.id); setIsArchived(item?.is_archived); }}>
                                        <Archive />{" "}{item?.is_archived ? "Unarchive" : "Archive"}
                                    </Dropdown.Item>}
                                    {item?.is_archived === 0 && item?.is_leaderboard === 0 && (<Dropdown.Item className={`${styles.ActionsBUListItem}`} onClick={(e) => { setOpenDeleteModal(false); setOpenLeaderBoardModal(true); setApplicationModalOpen(false); setArchiveModalOpen(false); setDeleteId(0); setArchiveId(item?.id); }}>
                                        <Award /> Add to Leaderboard
                                    </Dropdown.Item>)}
                                    {item?.is_prospect_applied !== 1 && isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect:delete") > -1 && (<Dropdown.Item className={`${styles.ActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setArchiveModalOpen(false); setApplicationModalOpen(false); setOpenLeaderBoardModal(false); setOpenDeleteModal(true); setDeleteId(item?.id); setArchiveId(0); }}>
                                        <Trash2 /> Delete
                                    </Dropdown.Item>)}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>

                        <div className={`${styles.prospectNameActionSec}`}>
                            <Tooltip title="Start a voice call">
                                <p className={`${styles.ProsUserName} ${styles.CallLink}`} onClick={(e) => { e.preventDefault(); initiateVoiceCall(item); }}>{item?.phone}</p>
                            </Tooltip>

                            {item?.afford_amount !== "" && item?.check_list?.income === 2 && (<span className={`${styles.ProspectDeclinedBadge} ${styles.AffordBadge}`}>Afford: ${item?.afford_amount}</span>)}
                            {item?.afford_amount !== "" && item?.check_list?.income === 1 && (<span className={`${styles.ProspectApprovedBadge} ${styles.AffordBadge}`}>Afford: ${item?.afford_amount}</span>)}
                        </div>

                        <div className={`${styles.ProsUserMandateSec}`} >
                            <Tooltip title={item?.credit_score !== "" ? "Credit Score - " + item?.credit_score : "Credit Score - N/A"} >
                                <span className={item?.check_list?.credit_score === 2 ? `${styles.MandateCheckSec} ${styles.Fail}` : item?.check_list?.credit_score === 1 ? `${styles.MandateCheckSec} ${styles.Active}` : `${styles.MandateCheckSec}`}>
                                    <img src="/static/img/credit-score-icon.svg" alt="" />
                                </span>
                            </Tooltip>
                            <Tooltip title={getSlaTooltipData(item)}>
                                <span className={item?.check_list?.income === 2 ? `${styles.MandateCheckSec} ${styles.Fail}` : item?.check_list?.income === 1 ? `${styles.MandateCheckSec} ${styles.Active}` : `${styles.MandateCheckSec}`}>
                                    <img src="/static/img/salary-icon.svg" alt="" />
                                </span>
                            </Tooltip>
                            <Tooltip title={item?.ever_had_bankruptcy !== "" ? "Bankruptcy - " + item?.ever_had_bankruptcy : "Bankruptcy - N/A"}>
                                <span className={item?.check_list?.bankruptcy === 2 ? `${styles.MandateCheckSec} ${styles.Fail}` : item?.check_list?.bankruptcy === 1 ? `${styles.MandateCheckSec} ${styles.Active}` : `${styles.MandateCheckSec}`}>
                                    <img src="/static/img/bankruptcy-icon.svg" alt="" />
                                </span>
                            </Tooltip>
                            <Tooltip title={item?.ever_case_filed !== "" ? "Housing Court Cases - " + item?.ever_case_filed : "Housing Court Cases - N/A"}>
                                <span className={item?.check_list?.housing_court_case === 2 ? `${styles.MandateCheckSec} ${styles.Fail}` : item?.check_list?.housing_court_case === 1 ? `${styles.MandateCheckSec} ${styles.Active}` : `${styles.MandateCheckSec}`}>
                                    <img src="/static/img/court-cases-icon.svg" alt="" />
                                </span>
                            </Tooltip>
                        </div>
                    </div>
                </div>
                <div className={`${styles.ProspectCardBodySec}`}>
                    <ul>
                        <li>
                            <p className={`${styles.Title}`}>Credit Score:</p>
                            <p className={`${styles.Content}`}>
                                {item?.credit_score !== "" ? item?.credit_score : "-"}{" "}
                                {parseInt(item?.is_credit_score_verify) === 1 && (<img src="/static/img/verified.svg" className={`${styles.Varified}`} alt="" />)}
                            </p>
                        </li>
                        {item?.income_type === "Voucher" ? (<li>
                            <p className={`${styles.Title}`}>Voucher:</p>
                            <p className={`${styles.Content}`}>{item?.voucher_amount !== "" ? "$" + item?.formatted_voucher_amount : "-"}</p>
                        </li>) : (<li>
                            <p className={`${styles.Title}`}>Salary:</p>
                            <p className={`${styles.Content}`}>{item?.income_per_year !== "" ? "$" + item?.formatted_income_per_year : "-"}</p>
                        </li>)}
                        <li>
                            <p className={`${styles.Title}`}>Current Rent:</p>
                            <p className={`${styles.Content}`}>{item?.current_rent !== "" ? "$" + item?.formatted_current_rent : "-"}</p>
                        </li>
                        <li>
                            <p className={`${styles.Title}`}>Move-In Date:</p>
                            <p className={`${styles.Content}`}>{item?.move_in_date !== "" ? item?.formatted_move_in_date : "-"}</p>
                        </li>
                        <li>
                            <p className={`${styles.Title}`}>Property:</p>
                            <p className={`${styles.Content} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/properties/details/" + item?.property_id); }}>{item?.property_name && item?.property_name !== "" ? item?.property_name : "-"}</p>
                        </li>
                        <li>
                            <p className={`${styles.Title}`}>Unit:</p>
                            <p className={`${styles.Content}`}>{item?.apt_no && item?.apt_no !== "" ? item?.apt_no : "-"}</p>
                        </li>
                        <li>
                            <p className={`${styles.Title}`}>Inbound:</p>
                            <p className={styles.Content}>
                                {item?.inbound_source && item?.inbound_source.trim() !== "" ? item?.inbound_source.split(",").map((source) => {
                                    const trimmedSource = source.trim();
                                    const classMap = {
                                        SMS: styles.Sms,
                                        "Contact Form": styles.CForm,
                                        "Google Form": styles.GForm,
                                        Web: styles.Web,
                                        "Manually Added": styles.MAdded,
                                    };

                                    const badgeClass = classMap[trimmedSource] || "";
                                    return (<span key={trimmedSource} className={`${styles.InfoStatusBadge} ${badgeClass}`}>{trimmedSource}</span>);
                                }) : "-"}
                            </p>
                        </li>
                        <li>
                            <p className={`${styles.Title}`}>Email Groups:</p>
                            <p className={`${styles.Content}`}>
                                {item?.email_groups?.length > 0 ? (<>
                                    {item?.email_groups[0]?.title}
                                    {item?.email_groups?.length > 1 && (<BootstrapTooltip title={<div className={`${styles.IncomeLineTooltip}`}>
                                        {item?.email_groups?.map((i, ind) => {
                                            if (ind === 0)
                                                return null;
                                            return (<p>#{ind}. {i?.title}</p>);
                                        })}
                                    </div>}>
                                        <span className={`${styles.MorePropertyBU}`}>+{item?.email_groups?.length - 1}</span>
                                    </BootstrapTooltip>)}
                                </>) : ("-")}
                            </p>
                        </li>
                        <li>
                            <p className={`${styles.Title}`}>Leaderboard:</p>
                            <p className={`${styles.Content}`}>
                                {item?.is_leaderboard === 1 ? (<div className={`${styles.LeaderboardTag}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); localStorage.setItem("leaderBoardProspectId", item?.id); redirect.push("/people/leaderboards"); }}>
                                    {item?.leaderboard_name !== "" && (<p>{item?.leaderboard_name}</p>)}
                                    {item?.is_leaderboard === 1 && (<img src="/static/img/leaderboard-badge-gold.png" className={`${styles.LeaderBadge}`} alt="" />)}
                                </div>) : ("-")}
                            </p>
                        </li>
                    </ul>
                </div>
                <div className={`${styles.ProspectCardFootSec}`}>
                    <p className={`${styles.ProsCardDate}`}>{moment.utc(item?.submitted_at).fromNow()}</p>
                    <div className={`${styles.FootStatSec}`}>
                        {item?.approval_remaining_days !== null && item?.approval_remaining_days <= 0 && (item?.current_status !== 3 && item?.current_status !== 4) && <Tooltip title={'Approval Overdue (' + (Math.abs(item?.approval_remaining_days) + 1) + ' days)'}><span className={`${styles.ProspectOverdueBadge}`}>Approval Overdue</span></Tooltip>}

                    </div>
                    <button className={`${styles.ProsCardMailBU}`} onClick={(e) => openProspectConversation(e, item)}>
                        {item?.unread_no > 0 && (<span>{item?.unread_no}</span>)}
                        <Mail />
                    </button>
                </div>
            </div>
        </Link>
    </div>)
}

export default ProspectCard;